import { render, staticRenderFns } from "./CampaignItemSetupBoth.vue?vue&type=template&id=1341c2db&scoped=true&"
import script from "./CampaignItemSetupBoth.vue?vue&type=script&lang=js&"
export * from "./CampaignItemSetupBoth.vue?vue&type=script&lang=js&"
import style0 from "./CampaignItemSetupBoth.vue?vue&type=style&index=0&id=1341c2db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1341c2db",
  null
  
)

export default component.exports